module.exports = __webpack_public_path__ + "img/12.860b2dc5.png";